import { BaseEntity } from '../../../admin/entity/store/types';
import { RiskToleranceDataset } from '../../../admin/risk-tolerance/store/types';
import { WorldCountriesList } from '../../../constants/worldCountriesList';
import { ClientRiskConversation, DocumentDatasetRiskTolerance, FieldValue } from '../../../datasets/instances/store/types';
import { DatasetFieldType, DatasetType } from '../../../datasets/store/types';
import { PieChartAnalyticsData } from '../../../shared/analytics/PieChart';
import { DropdownOption } from '../../../shared/dropdown/Dropdown';
import { ColumnSort, TableFilters } from '../../../shared/table/types';

export enum DocumentAnalyticsActionTypes {
    FETCH_DOCUMENT_SPREAD_ANALYTICS_STARTED = 'FETCH_DOCUMENT_SPREAD_ANALYTICS_STARTED',
    FETCH_DOCUMENT_SPREAD_ANALYTICS_SUCCESSFUL = 'FETCH_DOCUMENT_SPREAD_ANALYTICS_SUCCESSFUL',
    FETCH_DOCUMENT_SPREAD_ANALYTICS_FAILED = 'FETCH_DOCUMENT_SPREAD_ANALYTICS_FAILED',
    FETCH_ENTITY_SPREAD_ANALYTICS_STARTED = 'FETCH_ENTITY_SPREAD_ANALYTICS_STARTED',
    FETCH_ENTITY_SPREAD_ANALYTICS_SUCCESSFUL = 'FETCH_ENTITY_SPREAD_ANALYTICS_SUCCESSFUL',
    FETCH_ENTITY_SPREAD_ANALYTICS_FAILED = 'FETCH_ENTITY_SPREAD_ANALYTICS_FAILED',
    FETCH_ENTITY_JURISDICTION_ANALYTICS_STARTED = 'FETCH_ENTITY_JURISDICTION_ANALYTICS_STARTED',
    FETCH_ENTITY_JURISDICTION_ANALYTICS_SUCCESSFUL = 'FETCH_ENTITY_JURISDICTION_ANALYTICS_SUCCESSFUL',
    FETCH_ENTITY_JURISDICTION_ANALYTICS_FAILED = 'FETCH_ENTITY_JURISDICTION_ANALYTICS_FAILED',
    FETCH_JURISDICTION_DOCUMENTS_STARTED = 'FETCH_JURISDICTION_DOCUMENTS_STARTED',
    FETCH_JURISDICTION_DOCUMENTS_SUCCESSFUL = 'FETCH_JURISDICTION_DOCUMENTS_SUCCESSFUL',
    FETCH_JURISDICTION_DOCUMENTS_FAILED = 'FETCH_JURISDICTION_DOCUMENTS_FAILED',
    JURISDICTION_DOCUMENTS_SELECT_PAGE = 'JURISDICTION_DOCUMENTS_SELECT_PAGE',
    SET_SELECTED_COUNTRY = 'SET_SELECTED_COUNTRY',
    SET_COUNTRY_ENTITIES = 'SET_COUNTRY_ENTITIES',
    CLEAR_COUNTRY_ENTITIES = 'CLEAR_COUNTRY_ENTITIES',
    SET_DOCUMENT_ANALYTICS_TILE_IN_VIEW = 'SET_DOCUMENT_ANALYTICS_TILE_IN_VIEW',
    SET_SELECTED_MY_COMPANY_ENTITY = 'SET_SELECTED_MY_COMPANY_ENTITY',
    FETCH_ALL_MY_COMPANY_ENTITIES_STARTED = 'FETCH_ALL_MY_COMPANY_ENTITIES_STARTED',
    FETCH_ALL_MY_COMPANY_ENTITIES_SUCCESSFUL = 'FETCH_ALL_MY_COMPANY_ENTITIES_SUCCESSFUL',
    FETCH_ALL_MY_COMPANY_ENTITIES_FAILED = 'FETCH_ALL_MY_COMPANY_ENTITIES_FAILED',
    FETCH_DOCUMENT_RISK_TOLERANCE_STARTED = 'FETCH_DOCUMENT_RISK_TOLERANCE_STARTED',
    FETCH_DOCUMENT_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_DOCUMENT_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_DOCUMENT_RISK_TOLERANCE_FAILED = 'FETCH_DOCUMENT_RISK_TOLERANCE_FAILED',
    FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_STARTED = 'FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_STARTED',
    FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_FAILED = 'FETCH_ALL_DOCUMENTS_RISK_TOLERANCE_FAILED',
    FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_STARTED = 'FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_STARTED',
    FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_FAILED = 'FETCH_PAGINATED_DOCUMENTS_RISK_TOLERANCE_FAILED',
    SET_DOCUMENT_RISK_TOLERANCE_TABLE_FILTERS = 'SET_DOCUMENT_RISK_TOLERANCE_TABLE_FILTERS',
    CLEAR_DOCUMENT_RISK_TOLERANCE_TABLE_FILTERS = 'CLEAR_DOCUMENT_RISK_TOLERANCE_TABLE_FILTERS',
    SET_DOCUMENT_RISK_TOLERANCE_TABLE_COLUMN_SORT = 'SET_DOCUMENT_RISK_TOLERANCE_TABLE_COLUMN_SORT',
    SET_DOCUMENT_RISK_TOLERANCE_PAGE_SIZE = 'SET_DOCUMENT_RISK_TOLERANCE_PAGE_SIZE',
    DOCUMENT_RISK_TOLERANCE_PAGINATION_NEXT = 'DOCUMENT_RISK_TOLERANCE_PAGINATION_NEXT',
    DOCUMENT_RISK_TOLERANCE_PAGINATION_PREVIOUS = 'DOCUMENT_RISK_TOLERANCE_PAGINATION_PREVIOUS',
    FETCH_ALL_DATASETS_RISK_TOLERANCE_STARTED = 'FETCH_ALL_DATASETS_RISK_TOLERANCE_STARTED',
    FETCH_ALL_DATASETS_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_ALL_DATASETS_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_ALL_DATASETS_RISK_TOLERANCE_FAILED = 'FETCH_ALL_DATASETS_RISK_TOLERANCE_FAILED',
    SET_RISK_TOLERANCE_VIEW = 'SET_RISK_TOLERANCE_VIEW',
    SET_RISK_TOLERANCE_COMPLETED = 'SET_RISK_TOLERANCE_COMPLETED',
    SET_ENTITY_DOCUMENT_RISK_TOLERANCE_VIEW = 'SET_ENTITY_DOCUMENT_RISK_TOLERANCE_VIEW',
    SET_PRE_EXECUTION_DOCUMENT_RISK_TOLERANCE_VIEW = 'SET_PRE_EXECUTION_DOCUMENT_RISK_TOLERANCE_VIEW',
    FETCH_DATASET_FIELD_RISK_TOLERANCE_STARTED = 'FETCH_DATASET_FIELD_RISK_TOLERANCE_STARTED',
    FETCH_DATASET_FIELD_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_DATASET_FIELD_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_DATASET_FIELD_RISK_TOLERANCE_FAILED = 'FETCH_DATASET_FIELD_RISK_TOLERANCE_FAILED',
    SET_RISK_TOLERANCE_DATASET_ID = 'SET_RISK_TOLERANCE_DATASET_ID',
    GET_SELECTED_RISK_FIELD_DOCUMENT_META = 'GET_SELECTED_RISK_FIELD_DOCUMENT_META',
    RESET_DOCUMENT_FIELD_SELECTION = 'RESET_DOCUMENT_FIELD_SELECTION',
    SET_DATASET_FIELD_RISK_TOLERANCE_TABLE_FILTERS = 'SET_DATASET_FIELD_RISK_TOLERANCE_TABLE_FILTERS',
    CLEAR_DATASET_FIELD_RISK_TOLERANCE_TABLE_FILTERS = 'CLEAR_DATASET_FIELD_RISK_TOLERANCE_TABLE_FILTERS',
    SET_DATASET_FIELD_RISK_TOLERANCE_TABLE_COLUMN_SORT = 'SET_DATASET_FIELD_RISK_TOLERANCE_TABLE_COLUMN_SORT',
    SET_DATASET_FIELD_RISK_TOLERANCE_PAGE_SIZE = 'SET_DATASET_FIELD_RISK_TOLERANCE_PAGE_SIZE',
    DATASET_FIELD_RISK_TOLERANCE_PAGINATION_NEXT = 'DATASET_FIELD_RISK_TOLERANCE_PAGINATION_NEXT',
    DATASET_FIELD_RISK_TOLERANCE_PAGINATION_PREVIOUS = 'DATASET_FIELD_RISK_TOLERANCE_PAGINATION_PREVIOUS',
    SET_SELECTED_DATASET_RISK_FIELD = 'SET_SELECTED_DATASET_RISK_FIELD',
    REDIRECT_TO_DOCUMENT_INSTANCE = 'REDIRECT_TO_DOCUMENT_INSTANCE',
    FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_STARTED = 'FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_STARTED',
    FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_FAILED = 'FETCH_ENTITY_DOCUMENTS_RISK_TOLERANCE_FAILED',
    FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_STARTED = 'FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_STARTED',
    FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL = 'FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_SUCCESSFUL',
    FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_FAILED = 'FETCH_ALL_PRE_EXECUTION_DOCUMENTS_RISK_TOLERANCE_FAILED',
    RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_STARTED = 'RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_STARTED',
    RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_SUCCESSFUL = 'RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_SUCCESSFUL',
    RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_FAILED = 'RECALCULATE_MY_DOCUMENT_RISK_TOLERANCE_FAILED',
    TOGGLE_RECALCULATE_CONFIRMATION_MODAL = 'TOGGLE_RECALCULATE_CONFIRMATION_MODAL',
    TOGGLE_SHOW_OVERRIDE_RISK_RATING = 'TOGGLE_SHOW_OVERRIDE_RISK_RATING',
    TOGGLE_INCLUDE_PRE_EXECUTION_ANALYTICS = 'TOGGLE_INCLUDE_PRE_EXECUTION_ANALYTICS'
}

export enum DocumentAnalyticsChart {
    DOCUMENT_ENTITY_SPREAD = 'document entity spread',
    DOCUMENT_SPREAD = 'document spread',
    ENTITY_SPREAD = 'entity spread',
    ENTITY_JURISDICTION = 'entity jurisdiction',
    JURISDICTION_DOCUMENTS = 'jurisdiction documents',
    DOCUMENT_RISK_TOLERANCE = 'document risk tolerance',
    ENTITY_DOCUMENT_RISK_TOLERANCE = 'entity document risk tolerance',
    PRE_EXECUTION_DOCUMENT_RISK_TOLERANCE = 'pre execution document risk tolerance'
}

export enum DocumentRiskView {
    DOCUMENTS = 'documents',
    DOCUMENT_BREAKDOWN = 'document breakdown',
    DATASETS = 'datasets',
    DATASET_FIELD = 'dataset field'
}

export enum PreExecutionDocumentRiskView {
    PRE_EXECUTION_DOCUMENTS = 'pre execution documents',
    PRE_EXECUTION_DOCUMENT_BREAKDOWN = 'pre execution document breakdown',
    PRE_EXECUTION_DATASETS = 'pre execution datasets',
    PRE_EXECUTION_DATASET_FIELD = 'pre execution dataset field'
}

export enum EntityDocumentRiskView {
    ENTITY_DOCUMENTS = 'entity documents',
    ENTITY_DOCUMENT_BREAKDOWN = 'entity document breakdown',
    ENTITY_DATASETS = 'entity documents datasets',
    ENTITY_DATASET_FIELD = 'entity documents dataset field'
}

export interface EntityJurisdictionAnalytics extends BaseEntity {
    jurisdiction: string | null;
    selectedMyCompanyEntity: number | null;
    documents: number;
}

export interface JurisdictionList extends WorldCountriesList {
    entities: CountryEntity[];
    documents: number;
}

interface CountryProperty {
    name: string;
}

interface ContinentProperty {
    continent: string;
}

interface CountryGeometry {
    type: string;
    coordinates: number | number[] | number[][] | number[][][] | number[][][][];
}

export interface Country {
    id: string;
    type: string;
    properties: CountryProperty;
    geometry: CountryGeometry;
    value?: number;
    entities?: CountryEntity[];
}

export interface Continent {
    type: string;
    properties: ContinentProperty;
    geometry: CountryGeometry;
}

export interface CountryEntity {
    name: string;
    entityId: number;
    onWatchlist?: number;
}

export interface CountryEntityInformation {
    name: string;
    entities: CountryEntity[];
}

export interface BaseArkDocument {
    documentId: number;
    documentDescription: string;
    documentName: string;
    entityAName: string;
    entityBName: string;
}

export interface DocumentRiskTolerance {
    documentRiskToleranceId?: number;
    originalDocumentId: number;
    documentRiskFields: DocumentDatasetRiskTolerance[];
    overrideRiskRating: number;
    riskRating: number;
    maxRating: number;
    percentage: number;
    overridePercentage: number;
    documentName: string;
    documentDescription: string;
    entityAName: string | null;
    entityBName: string | null;
    dateChecked?: string;
}

export interface AllDocumentsRiskTolerance {
    overallPercentage: number;
    overallOverridePercentage: number;
    totalDocuments: number;
    riskHasUpdated: boolean;
    isRecalculating: boolean;
}

export interface TableDocumentsRiskToleranceDB {
    originalDocumentId: number;
    datasetInstanceId: number;
    documentName: string;
    documentDescription: string;
    partyA: string | null;
    partyB: string | null;
    riskRating: string;
    overrideRiskRating: string;
}

export interface TableDocumentsRiskTolerance {
    documents: TableDocumentsRiskToleranceDB[];
    total: number;
}

export interface DocumentRiskBreakdown {
    datasetType: DatasetType;
    datasetId: number;
    fieldId: string;
    fieldType: DatasetFieldType;
    label: string;
    valueElement: JSX.Element;
    weighting: number;
    riskLevel: number;
    overrideRiskLevel: number;
    sectionId?: string | null;
    rowId?: string;
    rowLabel?: string;
    clientRiskConversation: ClientRiskConversation[];
}

export interface PaginatedDatasetFieldRiskTolerance {
    documents: DocumentFieldRiskToleranceAnalytics[];
    total: number;
    overallPercentage: number;
    overallOverridePercentage: number;
}

export interface DatasetFieldRiskTolerance {
    fieldLabel: string;
    rowLabel?: string;
    fieldPercentage: number;
    overrideFieldPercentage: number;
    fieldValue: FieldValue;
    fieldType: DatasetFieldType;
}

export interface DocumentFieldRiskToleranceAnalytics {
    datasetType: DatasetType;
    documentRiskToleranceId: number;
    originalDocumentId: number;
    datasetInstanceId: number;
    documentName: string;
    documentDescription: string;
    partyA: string | null;
    partyB: string | null;
    riskTolerance: DatasetFieldRiskTolerance[];
}

export interface DocumentAnalyticsState {
    tileInView: DocumentAnalyticsChart | null;
    documentSpread: PieChartAnalyticsData[];
    entitySpread: PieChartAnalyticsData[];
    entityJurisdiction: EntityJurisdictionAnalytics[];
    jurisdictionDocuments: BaseArkDocument[];
    totalDocuments: number;
    documentPage: number;
    fetchingAnalytics: DocumentAnalyticsChart[];
    fetchingMyCompanies: boolean;
    analyticsError: string | null;
    selectedCountry: string | null;
    countryEntities: CountryEntityInformation | null
    countryEntityModalOpen: boolean;
    selectedMyCompanyEntityId: number | null;
    availableAnalyticsEntities: DropdownOption[];
    documentRiskTolerance: DocumentRiskTolerance | null;
    documentRiskToleranceView: DocumentRiskView;
    entityDocumentRiskToleranceView: EntityDocumentRiskView;
    preExecutionDocumentRiskToleranceView: PreExecutionDocumentRiskView;
    documentRiskToleranceLoading: boolean;
    allDocumentsRiskTolerance: AllDocumentsRiskTolerance;
    entityDocumentsRiskTolerance: AllDocumentsRiskTolerance;
    preExecutionDocumentsRiskTolerance: AllDocumentsRiskTolerance;
    allDatasetsRiskTolerance: RiskToleranceDataset[];
    fetchingRiskToleranceDocuments: boolean;
    paginatedRiskToleranceDocuments: TableDocumentsRiskToleranceDB[];
    totalPaginatedRiskToleranceDocuments: number;
    riskToleranceDocumentsPage: number;
    riskToleranceDocumentsPageSize: number;
    riskToleranceDocumentsFilters: TableFilters;
    riskToleranceDocumentsSort: ColumnSort | undefined;
    selectedRiskToleranceParentDatasetId: number | null;
    selectedRiskToleranceChildDatasetId: number | null;
    selectedRiskToleranceDatasetFieldId: string | null;
    paginatedDatasetFieldRiskTolerance: DocumentFieldRiskToleranceAnalytics[];
    paginatedDatasetFieldRiskToleranceTotal: number;
    paginatedDatasetFieldRiskToleranceOverallPercentage: number;
    paginatedDatasetFieldRiskToleranceOverallOverridePercentage: number;
    documentRiskFieldTolerance: DocumentFieldRiskToleranceAnalytics | null;
    riskToleranceDatasetFieldPage: number;
    riskToleranceDatasetFieldPageSize: number;
    riskToleranceDatasetFieldFilters: TableFilters;
    riskToleranceDatasetFieldSort: ColumnSort | undefined;
    recalculateConfirmationModalOpen: boolean;
    showOverrideRiskRating: boolean;
    includePreExecutionAnalytics: boolean;
}
